import array from "dojo/_base/array";
import declare from	"dojo/_base/declare";
import lang from "dojo/_base/lang";
import _ from "underscore";
import PostRequest from	"csi/comm/PostRequest";
import util from "csi/util";
import xml from	"csi/xml";
import MassReplaceFormulatedProduct from "./MassReplaceFormulatedProduct";

const FIELD_TO = "FPMassReplaceTo",
	FIELD_RETAIN = "FPMassReplaceRetain";

const MassReplaceFPItem = declare(MassReplaceFormulatedProduct, {
	/**
	*@override
	* Collect the data from the Form and the FPItems selected in the second step table, then send the request
	*/
	process: function() {
		const fd = this.m_formData;
		const req = new PostRequest("FormulatedProduct", "FPItemMassReplace")
			.addParameter("From", this.m_urlParent)
			.addParameter("To", fd.getFieldValue(FIELD_TO))
			.addParameter("RetainValues", fd.getFieldValue(FIELD_RETAIN));

		const nodes = fd.getSelectedNodes();
		if (nodes.length) {
			req.addParameter(xml.PROP_AGGREGATE_ADDS, array.map(nodes, xml.nodeGetURL));
		}
		// C8-50085: Temporary fix to defect with ProgressStep implementation (C8-50755)
		//req.addParameter("ProgressId", util.uuid());

		req.post({}).then(lang.hitch(this, this._onPublishResponse));
	},
});

export = MassReplaceFPItem;
